import { Locality } from "@common/models";
import Divider from "@components/general/Divider";
import Price from "@components/Price";
import { IAppState } from "@misc/State";
import Translate from "@service/Translate";
import { FC, Fragment } from "react";
import { useSelector } from "react-redux";
import ItineraryPanel from "./ItineraryPanel";
import PassengerInfoItem from "./PassengerInfoItem";

const PassengersInfo: FC = () => {
    const { tr } = Translate;
    const { pnrInfo, routes } = useSelector((state: IAppState) => ({
        pnrInfo: state.pnrInfo,
        routes: state.routes
    }));
    const locality = routes.find(r => pnrInfo.originDestinations?.find(od => r.origin === od.origin.code && r.destination === od.destination.code))?.locality || Locality.Domestic;

    const footer = <div className="payment-details-footer row spa-0 flex">
        <div className="payment-details-footer-item col-1-auto">
            {tr("total")}
        </div>
        <div className="payment-details-footer-item col-1-auto">
            <Price amount={pnrInfo?.pricingInfo?.totalPrice} currencyUnitVisiblity currencyFontSize="12px" />
        </div>
    </div>;

    return (
        <div className="itinerary-passenger-details">
            <ItineraryPanel
                title={tr("passenger")}
                footer={footer}
            >
                <div className="passenger-details-table">
                    <div className="passenger-details-header">
                        <div className="passenger-details-header-item name">
                            {tr("full_name")}
                        </div>
                        {
                            pnrInfo?.travelers?.length && pnrInfo?.travelers[0]?.tickets?.length ?
                                <div className="passenger-details-header-item ticket-number" >
                                    {tr("ticket_number")}
                                </div>
                                : ''
                        }
                        <div className="passenger-details-header-item passport-id">
                            {tr(locality === Locality.International ? "passport_code" : "national_code")}
                        </div>
                        <div className="passenger-details-header-item sharing-btn" />
                        <div className="passenger-details-header-item price-section">
                            {tr("fare")}
                        </div>
                    </div>
                    {
                        pnrInfo?.travelers?.map((traveler, index) =>
                            <Fragment key={index}>
                                <PassengerInfoItem
                                    traveler={traveler}
                                    locality={locality}
                                />
                                {index < (pnrInfo?.travelers?.length as number) - 1 ? <Divider mode="perforation" orientation="horizontal" /> : ""}
                            </Fragment>
                        )
                    }
                </div>
            </ItineraryPanel>
        </div>
    )
}

export default PassengersInfo;